import React from "react";
import {
  Edit,
  SimpleForm,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  BooleanInput,
  FormDataConsumer,
  required,
  SelectInput,
  ReferenceField,
  TextField,
} from "react-admin";
import FormContainer from "../common/FormContainer";
import useUpdateWithValidation from "../common/useUpdateWithValidation";

import DomainManagerSelectInput from "./DomainManagerSelectInput";
import { validateDomain } from "./validators";

const DomainEdit = () => {
  const save = useUpdateWithValidation("Domain", { redirectTo: "show" });

  return (
    <Edit>
      <SimpleForm onSubmit={save}>
        <FormContainer>
          <ReferenceInput
            source="customerId"
            reference="Customer"
            sort={{ field: "name", order: "ASC" }}
            filterToQuery={(searchText: any) => ({
              q: searchText,
            })}
          >
            <AutocompleteInput optionText="name" fullWidth />
          </ReferenceInput>
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="mainDomainId"
                reference="Domain"
                sort={{ field: "unicodeName", order: "ASC" }}
                filter={{ isMainDomain: true, customerId: formData.customerId }}
                filterToQuery={(searchText: any) => ({
                  q: searchText,
                })}
                allowEmpty
                {...rest}
              >
                <AutocompleteInput
                  optionText="unicodeName"
                  emptyText="- keine -"
                  fullWidth
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <TextInput
            source="domain"
            validate={validateDomain}
            helperText="Domain Name (ASCII), keine Sonderzeichen"
            fullWidth
          />
          <DomainManagerSelectInput
            source="managedBy"
            validate={required()}
            fullWidth
          />
          <FormDataConsumer>
            {({ formData, ...rest }) => (
              <ReferenceInput
                source="serviceBookingId"
                reference="ServiceBooking"
                sort={{ field: "bookedFrom", order: "ASC" }}
                filter={{ customerId: formData.customerId }}
                allowEmpty
                {...rest}
              >
                <SelectInput
                  optionText={
                    <>
                      <ReferenceField
                        source="serviceTemplateId"
                        reference="ServiceTemplate"
                        link={false}
                      >
                        <TextField source="name" />
                      </ReferenceField>{" "}
                      <TextField source="comment" />
                    </>
                  }
                  emptyText="- keine -"
                  fullWidth
                />
              </ReferenceInput>
            )}
          </FormDataConsumer>
          <BooleanInput source="mailEnabled" />
        </FormContainer>
      </SimpleForm>
    </Edit>
  );
};
export default DomainEdit;
